export default __webpack_public_path__ + "static/media/14.524a1d1c.webp";